module.exports = __webpack_public_path__ + "static/media/technology-lms-and-sis.19843d04.png";